import { render, staticRenderFns } from "./CabinetSubmenu.vue?vue&type=template&id=3b837c24&scoped=true&"
import script from "./CabinetSubmenu.vue?vue&type=script&lang=js&"
export * from "./CabinetSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./CabinetSubmenu.vue?vue&type=style&index=0&id=3b837c24&scoped=true&lang=css&"
import style1 from "./CabinetSubmenu.vue?vue&type=style&index=1&id=3b837c24&scoped=true&lang=css&"
import style2 from "./CabinetSubmenu.vue?vue&type=style&index=2&id=3b837c24&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b837c24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b837c24')) {
      api.createRecord('3b837c24', component.options)
    } else {
      api.reload('3b837c24', component.options)
    }
    module.hot.accept("./CabinetSubmenu.vue?vue&type=template&id=3b837c24&scoped=true&", function () {
      api.rerender('3b837c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/CabinetSubmenu.vue"
export default component.exports